<template>
    <div class="pagination-container row" aria-label="Pagination">
        <div class="col-sm-12 col-md-5">
            <div class="pagination-info dataTables_info">{{ pagingInfo }}</div>
        </div>
        <div class="col-sm-12 col-md-7">
            <div class="dataTables_paginate paging_simple_numbers">
                <ul class="pagination pagination-rounded">
                    <template v-for="n in totalPage">
                        <li
                            class="paginate_button page-item previous"
                            v-if="n == 1"
                            v-bind:class="{ 'disabled': (page==1) }"
                            :key="'prev'+n"
                        >
                            <a
                                class="page-link"
                                href="#"
                                @click.prevent="goPrevious()"
                                aria-label="Previous"
                            >
                                <i class="mdi mdi-chevron-left"></i>
                            </a>
                        </li>
                        <li
                            class="paginate_button page-item"
                            v-bind:class="{ 'active': (n==page) }"
                            :key="n"
                        >
                            <a
                                class="page-link"
                                href="#"
                                @click.prevent="go(n)"
                                :aria-label="'Page ' + n"
                            >{{ n }}</a>
                        </li>
                        <li
                            class="paginate_button page-item next"
                            v-if="n == totalPage"
                            v-bind:class="{ 'disabled': (page==totalPage) }"
                            :key="'next'+n"
                        >
                            <a
                                class="page-link"
                                href="#"
                                @click.prevent="goNext()"
                                aria-label="Next"
                            >
                                <i class="mdi mdi-chevron-right"></i>
                            </a>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /*     model: {
        prop: "metadata",
        event: "change",
    }, */
    props: {
        results: Array,
        metadata: Object
    },
    methods: {
        go(page) {
            // this.metadata.current_page = page;
            this.$emit("change", page);
        },
        goPrevious() {
            if (this.page > 1) {
                // this.metadata.current_page--;
                this.go(this.page - 1);
            }
        },
        goNext() {
            if (this.page < this.totalPage) {
                // this.metadata.current_page++;
                this.go(this.page + 1);
            }
        },
        reset(per_page) {
            this.$emit("reset", [per_page]);
        },
        perpageActiveClass(per_page) {
            if (this.metadata.per_page == per_page) {
                return "active";
            }
        }
    },
    computed: {
        page() {
            return this.metadata.current_page;
        },
        total() {
            if (this.metadata && this.metadata.total) {
                return this.metadata.total;
            } else {
                return this.results.length;
            }
        },
        totalPage() {
            return this.metadata.last_page;
        },
        pagingInfo() {
            if (this.metadata.from) {
                return (
                    "Showing " +
                    this.metadata.from +
                    " to " +
                    this.metadata.to +
                    " of " +
                    this.metadata.total
                );
            }
        }
    }
};
</script>

<style>
</style>
